import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_COLOR,
  TEXT_INFO_ALIGN,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_HEADING_LEVEL,
} from '@gcloud-npm/next12.components.text-info';
import IconLabel, {
  ICON_COLOR,
  ICON_LABEL_POSITION,
  ICON_LABEL_FONT_TYPE,
  ICON_KIND,
} from '@gcloud-npm/next12.components.icon-label-n';
import Button from '@gcloud-npm/next12.components.button-n';
import { SendSondaComponentNotShown } from '@/utils/functions';
import { useDispatch } from 'react-redux';
import styles from './styles';

const COMPONENT_NAME = 'ModuloPasos';

const ModuloPasos = (props) => {
  const dispatch = useDispatch();
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!props) {
      SendSondaComponentNotShown(COMPONENT_NAME, dispatch);
      return null;
    }
  }, []);

  const { title, steps, infoButton } = props;

  const btnTaggingInfo = {
    componentName: COMPONENT_NAME,
    componentVariation: 'all',
    componentContent: infoButton?.btnText || '',
    componentProduct: infoButton?.taggingInfo?.componentProduct || '',
  };

  return (
    <>
      <div className="moduloPasos container">
        <TextInfo
          text={title}
          kind={TEXT_INFO_KIND.HEADING}
          level={TEXT_INFO_HEADING_LEVEL.H2}
          align={TEXT_INFO_ALIGN.CENTER}
          color={TEXT_INFO_COLOR.WHITE}
          size={TEXT_INFO_SIZE.TITLE3}
          fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
          className="titleMiMovistar"
        />
        <div className="containerSteps">
          {steps.map((item, index) => {
            return (
              <IconLabel
                className="step"
                id={item.icon || ''}
                iconColor={ICON_COLOR.WHITE}
                iconSize={27}
                kind={ICON_KIND.LIGHT}
                label={item.step}
                labelFont={ICON_LABEL_FONT_TYPE.REGULAR}
                labelColor={ICON_COLOR.WHITE}
                labelPosition={ICON_LABEL_POSITION.BOTTOM}
                labelSize={18}
              />
            );
          })}
        </div>
        {infoButton.btnText && (
          <Button
            className="customButton"
            label={infoButton.btnText}
            taggingInfo={btnTaggingInfo}
            href={infoButton.href}
            onClick={infoButton.eventButton}
            forceExternal
          />
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ModuloPasos;

ModuloPasos.propTypes = {
  title: PropTypes.string,
  steps: PropTypes.array,
  infoButton: PropTypes.object,
};
ModuloPasos.defaultProps = {
  title: '',
  steps: [],
  infoButton: {},
};
